// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload {
    margin: 15px 0;
    padding: 15px 0;
    display: flex;
    justify-content: center;
    background-color: rgba(0,0,0,0.05)
}

.upload>div {
    align-self: center;
}

.upload input[type="file"] {
    font-size: small;
}`, "",{"version":3,"sources":["webpack://./src/css/upload.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".upload {\n    margin: 15px 0;\n    padding: 15px 0;\n    display: flex;\n    justify-content: center;\n    background-color: rgba(0,0,0,0.05)\n}\n\n.upload>div {\n    align-self: center;\n}\n\n.upload input[type=\"file\"] {\n    font-size: small;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
